<template>
  <section>
    <div class="mod-block">
      <h3 class="title">资质证照</h3>
      <el-form ref="form" :model="form" size="mini" class="mod-form">
        <el-form-item prop="fileId" :rules="[{ validator: $validate.required, trigger: 'blur', message: '请上传资质证照'}]">
          <el-upload
            :disabled="!!form.fileId || !validStatus"
            class="upload-demo"
            :action="actionStr"
            :limit="1"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList"
            accept=".zip,.rar">
            <el-button size="small" type="primary" @click="tips">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">*上传要求：需上传营业执照、中国商品条码系统会员证、专利、专利授权等，其他根据品类自行上传对应证照资料，仅支持上传一个rar、zip格式文件</div>
          </el-upload>
          <ul class="mod-filelist">
            <li v-for="(item, index) in fileList" :key="index"><span>{{item.fileName}}</span><a href="javascript:void(0);" class="del" @click="del(index)" v-if="validStatus">删除</a><a :href="item.url">下载</a></li>
          </ul>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>
<script>
  export default {
    inject: ['getComData'],
    props: ['size'],
    data () {
      return {
        status: '',
        baseURL: window.IPConfig.HOST ? (window.IPConfig.IP + ':' + window.IPConfig.HOST) : window.IPConfig.IP,
        imgPrefix: this.baseURL + '/contentmanagement/download/',
        // fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}]
        fileList: [],
        form: {
          fileId: '',
          fileName: ''
        }
      }
    },
    computed: {
      validStatus () {
        return !this.status || (!!this.status && (this.status == 7 || this.status == 8 || this.status == 16))
      },
      actionStr () {
        let str = this.action || (this.$config && this.$config.uploadUrl ? this.$config.uploadUrl : '/contentmanagement/file/uploadFiles')
        str = this.baseURL + str
        return str
      }
    },
    methods: {
      tips () {
        if (!!this.form.fileId) {
          this.$message('仅支持上传一个rar、zip格式文件')
        }
      },
      del (index) {
        this.fileList.splice(index, 1)
        this.form.fileId = ''
        this.form.fileName = ''
      },
      handleAvatarSuccess (res, file, fileList) {
        if (res && (res.code == 0)) {
          let {oldfilename, fileId} = res.result
          let url = this.baseURL + '/contentmanagement/file/down?id=' + fileId
          let obj = {fileName: oldfilename, url, fileId}
          this.fileList.push(obj)
          this.form = {fileId, fileName: oldfilename}
        }
      },
      beforeAvatarUpload (file) {
        if (!file.type.indexOf('zip') && !file.type.indexOf('rar')) {
          this.$message.error('仅支持rar、zip格式文件')
          return false
        }
        let sizeVal = this.size || 10 * 1024
        const size = file.size / 1024
        const isLt2M = (size < sizeVal || size == sizeVal)
        if (!isLt2M) {
          this.$message.error(`上传文件大小不能超过 ${sizeVal}MB!`)
        }
        return isLt2M
        return true
      }
    },
    mounted () {
      // 编辑
      let {editData} = this.getComData()
      if (editData.fileId) {
        Object.assign(this.form, {fileId: editData.fileId, fileName: editData.fileName})
        this.status = editData.status
        this.fileList.push({
          fileName: editData.fileName,
          url: this.baseURL + '/contentmanagement/file/down?id=' + editData.fileId,
          fileId: editData.fileId
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 20px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
  }
  .el-upload__tip {
    font-size: 12px;
    color:red;
  }
  /deep/ .el-upload-list__item {
    line-height: 20px;
    width: 300px;
  }
  .mod-filelist {
    width: 300px;
    font-size: 12px;
    margin-top: 10px;
    li {
      display: flex;
      -webkit-display: flex;
      align-items: center;
      span {
        display: block;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      a {
        display: block;
        margin-left: 5px;
        color: blue;
        &:hover {
          text-decoration: underline;
        }
      }
      .del {
        color: red;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/standard/qualification-certificate.vue